/* Bherdy theme behaviors — ported from the Manus build.
   1. Scroll-reveal: .bherdy-reveal elements gain .visible when entering viewport.
   2. Header: transparent over the home hero, solid black after 60px of scroll. */

(function () {
  // ---- Reveal on scroll (IntersectionObserver, threshold/margins from original) ----
  function initReveal() {
    var els = document.querySelectorAll('.bherdy-reveal:not(.visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -30px 0px' }
    );
    els.forEach(function (el) {
      observer.observe(el);
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) el.classList.add('visible');
    });
  }

  // ---- Header transparency over home hero ----
  function initHeader() {
    var wrap = document.querySelector('.shopify-section-group-header-group')
      ? document.querySelector('sticky-header') || document.querySelector('.section-header')
      : null;
    var target = document.querySelector('.section-header') || document.querySelector('sticky-header');
    if (!target) return;
    target.classList.add('bherdy-header-wrap');
    function onScroll() {
      target.classList.toggle('scrolled', window.scrollY > 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Expose the header height so the home hero can slide underneath it
    var header = document.querySelector('.section-header .header') || target;
    function setHeaderHeight() {
      // ceil + 1: a fractional header height must never leave a white gap
      // between the marquee and the hero pulled up beneath it
      var h = Math.ceil(header.getBoundingClientRect().height) + 1;
      document.documentElement.style.setProperty('--bherdy-header-h', h + 'px');
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
  }

  // ---- Cart drawer (bherdy-cart-drawer section) ----
  function initCartDrawer() {
    var root = document.querySelector('[data-bherdy-drawer]');
    if (!root) return;

    window.BherdyCart = {
      open: function () {
        root.classList.add('open');
        document.body.style.overflow = 'hidden';
      },
      close: function () {
        root.classList.remove('open');
        document.body.style.overflow = '';
      },
      refresh: async function () {
        var res = await fetch(window.Shopify.routes.root + '?sections=bherdy-cart-drawer,header');
        var data = await res.json();
        // swap drawer contents, preserving the open state on the root
        var doc = new DOMParser().parseFromString(data['bherdy-cart-drawer'], 'text/html');
        var fresh = doc.querySelector('[data-bherdy-drawer]');
        if (fresh) root.innerHTML = fresh.innerHTML;
        // update header cart bubble
        var headerDoc = new DOMParser().parseFromString(data.header, 'text/html');
        var freshBubble = headerDoc.getElementById('cart-icon-bubble');
        var currentBubble = document.getElementById('cart-icon-bubble');
        if (freshBubble && currentBubble) currentBubble.innerHTML = freshBubble.innerHTML;
      }
    };

    // Header cart icon opens the drawer instead of /cart
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('#cart-icon-bubble');
      if (cartLink) {
        e.preventDefault();
        window.BherdyCart.open();
        return;
      }
      if (e.target.closest('[data-drawer-close]')) {
        window.BherdyCart.close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('open')) window.BherdyCart.close();
    });

    // Quantity / remove buttons (event delegation survives re-renders)
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      root.classList.add('is-loading');
      try {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: Number(btn.dataset.qty) })
        });
        await window.BherdyCart.refresh();
      } finally {
        root.classList.remove('is-loading');
      }
    });
  }

  // ---- Quick-add: size/color panel embedded over the product card (opened by "+") ----
  function initQuickAdd() {
    if (window.__bherdyQA) return;
    window.__bherdyQA = true;

    var openCard = null;   // the card whose panel is currently open
    var current = null;    // its parsed product JSON
    var selected = {};     // { position: value }

    async function addToCart(id) {
      var res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      });
      if (!res.ok) throw new Error('add failed');
      if (window.BherdyCart) { await window.BherdyCart.refresh(); window.BherdyCart.open(); }
    }

    function closePanel() {
      if (openCard) {
        var p = openCard.querySelector('.bherdy-qa');
        if (p) { p.classList.remove('is-open'); var el = p; setTimeout(function () { el.remove(); }, 260); }
        openCard.classList.remove('bherdy-card--qa-open');
      }
      openCard = null; current = null; selected = {};
    }

    function resolve() {
      if (!current) return null;
      return current.variants.find(function (v) {
        return Object.keys(selected).every(function (pos) { return v.o[Number(pos) - 1] === selected[pos]; });
      });
    }

    function syncUI(panel) {
      panel.querySelectorAll('[data-value]').forEach(function (b) {
        b.classList.toggle('selected', selected[b.dataset.position] === b.dataset.value);
      });
      var v = resolve();
      var btn = panel.querySelector('[data-qa-add]');
      var lbl = panel.querySelector('[data-qa-add-label]');
      var priceEl = panel.querySelector('[data-qa-price]');
      if (v && v.available) { btn.disabled = false; btn.dataset.variantId = v.id; lbl.textContent = 'Add to Bag'; }
      else if (v) { btn.disabled = true; lbl.textContent = 'Sold out'; }
      else { btn.disabled = true; lbl.textContent = 'Select size'; }
      if (priceEl && v && v.price) priceEl.textContent = v.price;
    }

    function buildPanel(data) {
      var panel = document.createElement('div');
      panel.className = 'bherdy-qa';

      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'bherdy-qa__x';
      x.setAttribute('data-qa-close', '');
      x.setAttribute('aria-label', 'Close');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
      panel.appendChild(x);

      var opts = document.createElement('div');
      opts.className = 'bherdy-qa__opts';
      data.options.forEach(function (opt) {
        var group = document.createElement('div');
        group.className = 'bherdy-qa__group';
        var grid = document.createElement('div');
        grid.className = opt.color ? 'bherdy-qa__swatches' : 'bherdy-qa__sizes';
        opt.values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.dataset.position = opt.position;
          b.dataset.value = val.v;
          if (opt.color) { b.className = 'bherdy-qa__swatch'; b.style.setProperty('--sw', val.hex || '#ccc'); b.title = val.v; b.setAttribute('aria-label', val.v); }
          else { b.className = 'bherdy-qa__size'; b.textContent = val.v; }
          grid.appendChild(b);
        });
        group.appendChild(grid);
        opts.appendChild(group);
      });
      panel.appendChild(opts);

      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'bherdy-qa__add';
      add.setAttribute('data-qa-add', '');
      add.disabled = true;
      var price = document.createElement('span');
      price.className = 'bherdy-qa__price';
      price.setAttribute('data-qa-price', '');
      price.textContent = data.price || '';
      var lbl = document.createElement('span');
      lbl.setAttribute('data-qa-add-label', '');
      lbl.textContent = 'Select size';
      add.appendChild(price);
      add.appendChild(lbl);
      panel.appendChild(add);

      return panel;
    }

    function openOn(card, data) {
      closePanel();
      var media = card.querySelector('.bherdy-card__media');
      if (!media) return;
      current = data; selected = {}; openCard = card;
      var panel = buildPanel(data);
      media.appendChild(panel);
      card.classList.add('bherdy-card--qa-open');
      var firstAvail = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
      if (firstAvail) data.options.forEach(function (opt) { selected[opt.position] = firstAvail.o[opt.position - 1]; });
      syncUI(panel);
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-qa-open]');
      if (trigger) {
        e.preventDefault(); e.stopPropagation();
        var card = trigger.closest('.bherdy-card');
        if (!card) return;
        if (openCard === card) { closePanel(); return; }   // second click on "+" closes
        var dataEl = card.querySelector('.bherdy-card__qa');
        if (!dataEl) return;
        var data = JSON.parse(dataEl.textContent);
        if (data.variants.length === 1) { addToCart(data.variants[0].id).catch(function () {}); return; }
        openOn(card, data);
        return;
      }

      // clicks inside the open panel — never let them follow the card's product link
      var panel = e.target.closest('.bherdy-qa');
      if (panel) {
        e.preventDefault(); e.stopPropagation();
        if (e.target.closest('[data-qa-close]')) { closePanel(); return; }
        var opt = e.target.closest('[data-value]');
        if (opt) { selected[opt.dataset.position] = opt.dataset.value; syncUI(panel); return; }
        var add = e.target.closest('[data-qa-add]');
        if (add && !add.disabled) {
          var lbl = add.querySelector('[data-qa-add-label]');
          var orig = lbl.textContent;
          lbl.textContent = 'Adding…';
          addToCart(add.dataset.variantId).then(function () { closePanel(); }).catch(function () {
            lbl.textContent = 'Error'; setTimeout(function () { lbl.textContent = orig; }, 1500);
          });
        }
        return;
      }

      // a click anywhere else closes the open panel
      if (openCard) closePanel();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openCard) closePanel();
    });
  }

  function init() {
    initReveal();
    initHeader();
    initCartDrawer();
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run reveal when Shopify's theme editor injects/reorders sections
  document.addEventListener('shopify:section:load', initReveal);
})();
